"use strict";exports.__esModule = true;exports.default = void 0;var _default = {
  handleButtonClick(originalEvent) {
    if (!this.input.disabled) {
      var selected = !this.state.selected;
      this.state.selected = selected;
      this.emit('click', {
        selected,
        originalEvent
      });
    }
  },

  onInput(input) {
    this.state = {
      selected: input.selected || false
    };
  }
};exports.default = _default;module.exports = exports.default;